import { RESET, SET_SCHEDULE_STATE } from "./scheduleStateFilter.actionTypes";
import { SCHEDULE_STATE_ALL } from "./scheduleStateFilter.constants";

const initialState = {
  // "All" on load (AC-2). A saved view is the only thing that changes it.
  scheduleState: SCHEDULE_STATE_ALL,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SCHEDULE_STATE: {
      return { ...state, scheduleState: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
